module.exports = __webpack_public_path__ + "static/media/project3.ccd127e5.png";